import React from "react";
import "./Marquee.css";

export default function MarqueeText() {
  return (
    <div className="marquee-text d-none d-lg-block">
      <marquee direction="left" height="50px" width="100%" style={{color: "#0062cc"}} scrollamount="20">
        <h4>
          ☺️☺️☺️ To become the BEST in your life, never SETTLE for an average
          ☺️☺️☺️
        </h4>
      </marquee>
      <marquee
        direction="down"
        height="20px"
        width="100%"
        style={{ marginLeft: "49%" }}
      >
        <h5>
          <i className="fa fa-angle-double-down" style={{fontSize: "50px", color: "#ff8100"}}></i>
        </h5>
      </marquee>
    </div>
  );
}
